import axiosInstance from 'config/axios';

/**
 * @description Build metadata for the running backend artifact, generated by CI
 * into `build-info.json` immediately before the image is built.
 */
export interface BuildInfo {
  version: string;
  commit: string;
  branch: string;
  buildTime: string;
}

/**
 * @description Help service
 * @type {HelpService}
 */
const HelpService = {
  /**
   * @description Get help info
   * @returns {Promise<BuildInfo>} Backend build metadata
   */
  getHelpInfo: () => {
    return axiosInstance.get<BuildInfo>('/app-version');
  },
};

export default HelpService;
